import { setLoading } from '../common/slice'
import { setAllowedUsers } from './slice'
import { getAllowedRoles } from '../../../features/MyCommunity/api'
import type { RootState } from 'redux/createStore'
import { ThunkAction } from 'redux-thunk'
import { AnyAction } from 'redux'

export const getAllowedRolesList =
  (): ThunkAction<Promise<void>, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true))
      const { data } = await getAllowedRoles()
      dispatch(setAllowedUsers(data.results))
    } finally {
      dispatch(setLoading(false))
    }
  }
